import { createDropdown } from "../DropdownComponent/DropdownHelper";

export const WeldLayer = createDropdown("Weld Layer(s)");
export const Division = createDropdown("Division");
export const PlantLocation = createDropdown("Plant Location");
export const Welding_Standard = createDropdown("Welding Standard");
export const Current_Polarity = createDropdown("Current Polarity");
export const Backing = createDropdown("Backing");
export const Filler_Wire_With_Without = createDropdown("Filler Wire With/Without");
export const Flux_recrush = createDropdown("Flux from recrush");
export const Backing_Gas = createDropdown("Backing Gas");
export const WPQ_FM_Automatic_jointTracking = createDropdown("Automatic joint tracking (Machine)");
export const Direct_Visual = createDropdown("Direct/Remote visual control (Machine)");
export const Single_Pass = createDropdown("Multiple / Single Pass Per Side");
export const Arc_Transfer = createDropdown("Arc Transfer Mode(FCAW/GMAW)");
export const Consumable_Insert = createDropdown("Consumable Insert");
export const FM_Product_Form_GTAW = createDropdown("Filler Metal Product Form (GTAW)");
export const FM_Product_Form = createDropdown("Filler Metal Product Form");
export const TypeData = createDropdown("Type");
export const WeldedCoupon = createDropdown("Welded On Coupon");
export const Jointstatus = createDropdown("Joint Type");
// USED - Used in PQRProcess.js for layer data dropdown options
export const LayerData = createDropdown("Layer");
export const DeviationSeverityLevel = createDropdown("Deviation Severity Level");
export const Process_Cat = createDropdown("Process Category");
export const ProdSelectDropdown = createDropdown("WC in Kgs/Nos");

export const Plant_Location_WI = [
  { value: "", name: "Select" },
  { value: "DH - SPD", name: "DH - SPD" },
  { value: "DH - Nozzle", name: "DH - Nozzle" },
  { value: "DH - Assmbly 1", name: "DH - Assmbly 1" },
  { value: "DH - Assmbly 2", name: "DH - Assmbly 2" },
  { value: "DH - NPCIL", name: "DH - NPCIL" },
  { value: "DH - Yard 1", name: "DH - Yard 1" },
  { value: "DH - Yard 2", name: "DH - Yard 2" },
  { value: "DH - Yard 3", name: "DH - Yard 3" },
  { value: "Vik - P19 - Gr 1", name: "Vik - P19 - Gr 1" },
  { value: "Vik - P19 - Gr 2", name: "Vik - P19 - Gr 2" },
  { value: "Vik - P19 - Gr 3", name: "Vik - P19 - Gr 3" },
  { value: "Vik - P19 E", name: "Vik - P19 E" },

];

export const Tungsten_type = [
  { value: "Na", name: "NA" },
  { value: "EWTh 2", name: "EWTh 2" },
  { value: "EWCe 2", name: "EWCe 2" },
  { value: "EWLa 2", name: "EWLa 2" },
  { value: "EWZr 8", name: "EWZr 8" },
];

export const company_name = [
  { value: "Godrej & Boyce Mfg. Co. Ltd", name: "WPSH_CompanyName" },
];

export const division = [{ value: "PED" }];

export const Process = [{ value: "GTAW", name: "WPSD_Process" }];

export const Status = {
  StatusPending: "Pending For Approval",
  StatusApproved: "Approved",
  StatusRejected: "Rejected",
  StatusTempSaved: "Temporary Saved",
  StatusFreezed: "Freezed",
};
